import React, { useState } from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverBody,
  Box,
  Button,
  Spinner,
  Portal,
  PopoverFooter,
} from "@chakra-ui/react";
import JobProfileName from "./JobProfileName";

const SaveBtnPopOver = ({
  isSaveBtnLoading,
  getJobProfileName,
  onSave,
  jobProfileName,
  isSaveBtnPopOverDisabled,
}) => {
  const [isJobProfileNameAvailable, setIsJobProfileNameAvailable] =
    useState(true);
  return (
    <Popover placement="top">
      <PopoverTrigger>
        <Button
          size="sm"
          colorScheme="blue"
          disabled={isSaveBtnPopOverDisabled || isSaveBtnLoading}
        >
          {isSaveBtnLoading && <Spinner size="sm" mr={2} />}
          Save
        </Button>
      </PopoverTrigger>
      <Portal>
        <PopoverContent>
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverBody>
            <JobProfileName
              getJobProfileName={getJobProfileName}
              getIsJobProfileNameAvailable={setIsJobProfileNameAvailable}
            />
          </PopoverBody>
          <PopoverFooter>
            <Box textAlign="end">
              <Button
                size="sm"
                colorScheme="blue"
                onClick={onSave}
                disabled={!jobProfileName || !isJobProfileNameAvailable || isSaveBtnLoading}
              >
                {isSaveBtnLoading && <Spinner size="sm" mr={2} />}
                Save Jd
              </Button>
            </Box>
          </PopoverFooter>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};

export default SaveBtnPopOver;
